import { store } from "@src/redux/store";
import { getUserToken } from "./helpers";
import { clearAuth } from "@src/views/Auth/User/Login/store";

// A 401 only means our session is dead when the request actually carried the
// token we are still holding. A request sent without a token, or with one
// another tab has already rotated away, says nothing about the current session.
export const logoutIfSessionDead = (error) => {
  if (error?.response?.status !== 401) {
    return;
  }

  const headers = error?.config?.headers || {};
  const sentToken = (headers.Authorization || headers.authorization || "").replace(/^Bearer\s+/i, "");

  if (sentToken && sentToken === getUserToken() && store.getState().loginUser?.isLogin) {
    store.dispatch(clearAuth());
  }
};
